// components
import { ConditionalComponent } from 'components';

import './mainTable.scss';
import TableContent from './TableContent';
import TablePagination from './TablePagination';

// libs
import PageFilter from './PageFilter';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Function to extract default values
export function getDefaultValues(config) {
    const defaultValues = {};
    config.forEach(field => {
        if (field.defaultValue !== undefined) {
            if (field.name === 'dateRange') {
                defaultValues.startDate = field.defaultValue.startDate;
                defaultValues.endDate = field.defaultValue.endDate;
            } else {
                defaultValues[field.name] = field.defaultValue;
            }
        }
    });
    return defaultValues;
}

const MainTable = props => {
    const {
        tableHead,
        columns,
        tableData,
        fetchData,
        pagination,
        isLoading,
        isPaginationEnabled,
        error,
        noDataError,
        filters,
    } = props;

    const { pageNumber, pageSize, pageCount } = pagination;

    const [currentPage, setCurrentPage] = useState(1);
    const [filterData, setFilterData] = useState(getDefaultValues(filters));

    // Effect hook to fetch data when pageNumber or pageSize changes
    useEffect(() => {
        fetchData({ pageNumber: currentPage, pageSize, filterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageSize, filterData]);

    // Handler function for page change
    const onPageChange = values => {
        setCurrentPage(values);
    };

    const handleFilterSubmit = values => {
        let data = values;
        const dateRange = values?.dateRange || null;
        if (dateRange) {
            data = { ...data, ...dateRange };
            // eslint-disable-next-line
            delete data["dateRange"];
        }
        setFilterData(data);
    };

    return (
        <React.Fragment>
            <ConditionalComponent isVisible={tableHead}>
                <div className="table-head-container">{tableHead}</div>
            </ConditionalComponent>
            <ConditionalComponent isVisible={filters}>
                <PageFilter
                    configuration={filters}
                    handleFilterSubmit={handleFilterSubmit}
                    initialValues={filterData}
                    onReset={() => setFilterData(getDefaultValues(filters))}
                />
            </ConditionalComponent>
            <TableContent
                columns={columns}
                data={tableData}
                fetchData={fetchData}
                pagination={pagination}
                isLoading={isLoading}
                error={error}
                noDataError={noDataError}
            />
            {/* Render pagination component */}
            <ConditionalComponent
                isVisible={
                    isPaginationEnabled && tableData && tableData.length > 0
                }
            >
                <TablePagination
                    totalPageCount={pageCount}
                    currentPage={pageNumber}
                    onPageChange={onPageChange}
                    isLoading={isLoading}
                />
            </ConditionalComponent>
        </React.Fragment>
    );
};

// PropType validation for MainTable component
MainTable.propTypes = {
    tableHead: PropTypes.elementType,
    columns: PropTypes.array.isRequired,
    tableData: PropTypes.array.isRequired,
    error: PropTypes.string,
    pagination: PropTypes.object.isRequired,
    noDataError: PropTypes.object,
    fetchData: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isPaginationEnabled: PropTypes.bool,
    pageCount: PropTypes.number,
    filters: PropTypes.array,
};

export default MainTable;
